export default __webpack_public_path__ + "hourglass.415125db4a7f62f6.svg";